module.exports = __webpack_public_path__ + "img/gpt-addin-04.39e4b5c9.png";